const EventEmmiter = require('events')

function createBridge(iframe, domain) {
  const pArr = []
  var isIFrameLoaded = false

  iframe.addEventListener('load', () => {
    isIFrameLoaded = true
  })

  const ready = () => {
    if (isIFrameLoaded) {
      return Promise.resolve()
    }
    return new Promise((resolve, reject) => {
      iframe.addEventListener('load', () => {
        isIFrameLoaded = true
        resolve()
      })
    })
  }

  var eventSource = new EventEmmiter()
  let msgEventListener = function(e) {
    const data = e.data
    if (!data) return
    /*eslint-disable*/
    const { timestamp, type, content, args } = data
    if (timestamp) {
      const [p] = pArr.filter(p => p[0].timestamp === timestamp)
      data.err ? p[2](args) : p[1](args)
    } else {
      if (!data.type) return
      let content = data.content ? data.content : null
      eventSource.emit(data.type, JSON.parse(content), function(err, ...args) {
        iframe.contentWindow.postMessage(
          {
            type: 'callback',
            args,
            id: data.id,
            err
          },
          domain
        )
      })
    }
  }

  window.addEventListener('message', msgEventListener)
  return {
    postMessage: function(type, ...args) {
      const p = []
      const timestamp = Date.now()
      const promise = new Promise(function(resolve, reject) {
        p[1] = resolve
        p[2] = reject
        ready().then(function() {
          iframe.contentWindow && iframe.contentWindow.postMessage(
            {
              type,
              args,
              timestamp
            },
            domain
          )
        })
      })
      promise.timestamp = timestamp
      p[0] = promise
      pArr.push(p)
      return promise
    },
    addListener: function(type, fn) {
      eventSource.addListener(type, fn)
    },
    removeListener: function(type, fn) {
      eventSource.removeListener(type, fn)
    },
    removeMsgEventListener: function() {
      window.removeEventListener('message', msgEventListener)
    }
  }
}

export default createBridge
